import React from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import {
  WidgetContainer, WidgetHeader, WidgetTitle, ButtonsWrapper,
} from '../css';
import utils from '../../../../utils/utils';
import { routes } from '../../../../utils/constants';
import mockData from './mock';
import SliderDesktop from './SliderDesktop';
import SliderMobile from './SliderMobile';
import TertiaryButton from '../../buttons/TertiaryButton';

const NewsWidget = (props) => {
  const { fields, resolution } = props;
  const localFields = utils.isDisconnected ? mockData : fields;
  const { data: { drsearch } } = localFields;

  const viewAllNews = () => {
    window.location.href = routes.stories;
  };

  if (!localFields || !localFields.data) {
    return null;
  }

  if (!drsearch) {
    return null;
  }

  const { results: { items } } = drsearch;

  const news = items.filter((item) => (item.item
    && (item.item.heading && item.item.heading.value)
    && (
      (item.item.thumbnailImage && item.item.thumbnailImage.jss && item.item.thumbnailImage.jss.value && item.item.thumbnailImage.jss.value.src)
      || (item.item.heroImage && item.item.heroImage.jss && item.item.heroImage.jss.value && item.item.heroImage.jss.value.src)
    )
  ));

  if (!news || news.length === 0) {
    return null;
  }

  return (

    <WidgetContainer type="fluid">
      <div className="wrapper">
        <WidgetHeader>
          <WidgetTitle>{t('LatestNews')}</WidgetTitle>
        </WidgetHeader>
      </div>

      {(resolution === 'mobile') ? <SliderMobile news={news} /> : <SliderDesktop news={news} />}

      <ButtonsWrapper>
        <TertiaryButton
          label={t('ViewAllNews')}
          onClick={viewAllNews}
          size="small"
          showArrow
        />
      </ButtonsWrapper>

    </WidgetContainer>
  );
};

NewsWidget.propTypes = {
  fields: PropTypes.object,
  resolution: PropTypes.string,
};

export default NewsWidget;
